import { t } from '@/plugins/i18n'

// 发货状态
const cancelStatusDict = {
  1: t('未取消'),
  2: t('取消中'),
  3: t('取消成功'),
  4: t('保留库存')
}

// 商品申请取消 直发
export const canApplyCancel = (row: any, rowItem: any) => {
  // <!-- platformOrderType 1直发 2囤货
  //     statusList 商品状态: 1-待采购; 2-采购中; 3-已采购; 4-国内运输中; 5-已入库; 6-检品中; 7-已上架(已清算); 8-待发货; 9-已发货; 10-处理中的次品和异常; 11-不可退货次品; 12-取消成功; 13-保留库存 14-在途库存 -->
  const statusList: any = row.orderItemStatus.split(',').map((v: string) => Number(v))
  return (
    !(
      // 直发订单 存在 1-待采购; 2-采购中; 3-已采购; 4-国内运输中; 5-已入库; 6-检品中; 7-已上架(已清算);10-处理中的次品和异常; 可以取消
      (rowItem.platformOrderType === 1 &&
      (!statusList.some((t: any) => [1, 2, 3, 4, 5, 6, 7, 10, 14].indexOf(t) > -1))) ||
      // 囤货订单 1-待采购;可以取消
      (rowItem.platformOrderType === 2 &&
        statusList.some((t: any) => t > 1))
    )
  ) &&
  // 必须是没有未取消商品才能取消
  row.cancelStatus === 1 &&
  // 保留库存也不允许取消
  row.cancelProgress !== 2
}

// 商品申请取消 囤货 采购中状态不可
export const canStoreApplyCancel = (row: any) => row.cancelStatus < 3 && !row.orderItemStatus.includes('2')
